import ServiceBusController from "servicestack/service-bus.controller";
import CartItem from "emun.cart/cart-item.model";
import labels from "emun.order/_labels";
import sendEmailPrompt from "servicestack/email/send-email-prompt";
import resolve from "ioc/resolve";
import shoppingConfig from "emun.shopping/shopping.config";
import cartConfig from "emun.cart/cart.config";

export default class EnterPaymentController extends ServiceBusController {
	constructor($cart, $scope, $sce, $rootScope) {
		super($cart, $scope, $sce);
		let $ctrl = this;
		$ctrl.$sce = $sce;
	}
	$onInit() {
		const $ctrl = this;
		const $rootScope = resolve("$rootScope");
		$ctrl.labels = labels;
		$ctrl.cartConfig = cartConfig;
		$ctrl.shoppingConfig = shoppingConfig;
		$ctrl.loading = new Date();
		$ctrl.months = $rootScope.$dates.monthNumbers; // Needed???
		$ctrl.years = $rootScope.$dates.getYears(); // Needed???
		$ctrl.paymentMethod = {};
		$rootScope.$on("creditCardCreated", (e, args) => {
			$ctrl.applyPaymentMethod(args.ID, $ctrl.cartId);
		});

		$ctrl.bus
			.send(`Cart/${$ctrl.cartId}.json?IncludeProducts=1&Token=${$ctrl.token}`)
			.then(cr => {
				if (cr.data.results.length) {
					const [{ items, ...cart }] = cr.data.results;
					$ctrl.cart = cart;
					let retailerId = $ctrl.retailerId || $ctrl.cart.retailerId;
					let vendorCustId = $ctrl.cart.vendorCustomerId || $ctrl.retailerId || $ctrl.$cart.retailerId;
					$ctrl.items = items;
					$ctrl.bus.send("PayFabric/GetToken.json").then(function(res) {
						if (res.data) {
							$ctrl.token = res.data;
							var url = $ctrl.cartConfig.payfabricWalletPage + vendorCustId + "&token=" + $ctrl.token;
							$ctrl.payfabricWalletPage = $ctrl.$sce.trustAsResourceUrl(url);
							// $ctrl.bus
							// .send("QueryRetailers.json?Id=" + retailerId)
							// .then(function (response) {
							// 	if (response.data.results.length > 0) {
							// 		$ctrl.retailer = response.data.results[0];
							// 		if ($ctrl.$cart.billingLocation) {
							// 			if ($ctrl.$cart.billingLocation.address) url = url + "&Street1=" + $ctrl.$cart.billingLocation.address;
							// 			if ($ctrl.$cart.billingLocation.city) url = url + "&City=" + $ctrl.$cart.billingLocation.city;
							// 			if ($ctrl.$cart.billingLocation.state) url = url + "&State=" + $ctrl.$cart.billingLocation.state;
							// 			if ($ctrl.$cart.billingLocation.zip) url = url + "&Zip=" + $ctrl.$cart.billingLocation.zip;
							// 			if ($ctrl.$cart.billingLocation.country) url = url + "&Country=" + $ctrl.$cart.billingLocation.country;
							// 		} else if ($ctrl.retailer.billingLocadtion) {
							// 			if ($ctrl.retailer.billingLocation.address) url = url + "&Street1=" + $ctrl.retailer.billingLocation.address;
							// 			if ($ctrl.retailer.billingLocation.city) url = url + "&City=" + $ctrl.retailer.billingLocation.city;
							// 			if ($ctrl.retailer.billingLocation.state) url = url + "&State=" + $ctrl.retailer.billingLocation.state;
							// 			if ($ctrl.retailer.billingLocation.zip) url = url + "&Zip=" + $ctrl.retailer.billingLocation.zip;
							// 			if ($ctrl.retailer.billingLocation.country) url = url + "&Country=" + $ctrl.retailer.billingLocation.country;
							// 		}
							// 		$ctrl.payfabricWalletPage = $ctrl.$sce.trustAsResourceUrl(url);
							// 	}
							// });
				
						}
					});
					window.addEventListener('message', $ctrl.cardEntered, false);
				}
			})
			.finally(() => {
				$ctrl.loading = false;
			});
	}
	cardEntered(e) {
		const $ctrl = this;
		let $rootScope = resolve("$rootScope");
		if (e.data != null && e.data != 'undefined') {
			//handle wallet response
			const obj = JSON.parse(e.data);
			if (obj != null) {
				if (obj.Event == 'OnWalletUpdateCompleted') {
					var result = obj.Result;
					if (result != null && result === true) {
						var CardID = obj.ID;
					}
				} else if (obj.Event == 'OnWalletCreateCompleted') {
					var CardID = obj.ID;
					if (CardID != null) {
						$rootScope.$broadcast("creditCardCreated", obj);
						//$ctrl.applyPaymentMethod(CardID, $ctrl.cartId);
					}
				}
			}
		}
   }

	applyPaymentMethod(CardID, cartId) {
		const $ctrl = this;
		let paymentMethod = {};
		$ctrl.bus.read(`PayFabric/GetWallets?Customer=${$ctrl.cart.vendorCustomerId}`).then(function(res) {
			if (res.data.length) {
				let selCC = res.data.filter(
					(cc) => cc.id === CardID
				)[0];
				paymentMethod.id = selCC.id;
				paymentMethod.token = selCC.id;
				paymentMethod.tokenizationProvider = "PayFabric";
				paymentMethod.type = selCC.cardName;
				paymentMethod.address = selCC.billto.line1;
				paymentMethod.address2 = selCC.billto.line2;
				paymentMethod.city = selCC.billto.city;
				paymentMethod.state = selCC.billto.state;
				paymentMethod.zip = selCC.billto.zip;
				paymentMethod.country = selCC.billto.country;
				paymentMethod.expiration = selCC.expDate;
				paymentMethod.name = selCC.cardHolder.firstName + " " + selCC.cardHolder.lastName;
				paymentMethod.number = selCC.account;
				paymentMethod.lastFour = selCC.account.substring((selCC.account.length - 4), 4);
				let request = Object.assign({ cartId: cartId || $ctrl.cart.id }, paymentMethod);
				request.phone = (request.phone || "").replace(/\D/gi, "");
				if (
					paymentMethod.personName &&
					paymentMethod.personName.full &&
					!paymentMethod.name
				) {
					request.name = paymentMethod.personName.full;
				}
				request.fullName = request.name;
				request.personName = { full: request.name };
				$ctrl.submitting = new Date();
				return $ctrl.bus
					.send("ApplyPaymentMethod.json", request).then(res =>
					{
						$ctrl.done = res.data;
						$ctrl.submitting = false;
						$ctrl.submitted = new Date();
					},
					res => {
						$ctrl.failed = res.data;
						$ctrl.submitting = false;
					}
				);
					}
		})

	}

}
